import type { UiSettings } from "../storage.ts";
import type { GatewaySessionRow } from "../types.ts";
import { parseSessionKeyPath, type SessionKeyPath } from "../chat/session-key-path.ts";

export function resolveSessionsScopePath(settings: UiSettings): SessionKeyPath {
  if (settings.sessionsScopeLinked) {
    return parseSessionKeyPath(settings.sessionKey);
  }
  return settings.sessionsScopePath;
}

export function sessionKeyMatchesScopePath(sessionKey: string, path: SessionKeyPath): boolean {
  const entryPath = parseSessionKeyPath(sessionKey);
  for (let i = 0; i < 4; i++) {
    const want = (path[i] ?? "").trim();
    if (!want) {
      continue;
    }
    if ((entryPath[i] ?? "").trim() !== want) {
      return false;
    }
  }
  return true;
}

export function filterSessionRows(
  rows: GatewaySessionRow[],
  settings: UiSettings,
): GatewaySessionRow[] {
  if (settings.sessionsViewAll) {
    return rows;
  }
  const path = resolveSessionsScopePath(settings);
  if (!path.some((segment) => segment.trim().length > 0)) {
    return rows;
  }
  return rows.filter((row) => sessionKeyMatchesScopePath(row.key, path));
}
